import { OrganizationTo } from "./organizationTo";

export class PositionAliasTo {
    id: number;
    org: OrganizationTo;
    positionId: number;
    alias: string;

    constructor(object?: any) {
        this.id = object?.id;
        if (object?.hasOwnProperty('org') && object?.org) {
            this.org = new OrganizationTo(object.org);
        }
        this.positionId = object?.positionId;
        this.alias = object?.alias;
    }
}